export const STATUS_FILTER_COLOR_MAPPING = {
	ACTIVE: {
		button: 'bg-blue-light',
		count: 'bg-opacity-10 bg-white'
	},
	INACTIVE: {
		button: 'bg-white text-grey-dark font-medium text-sm',
		count: 'bg-grey-subtle'
	}
}

export const ProgramType = {
	RECURRING: 'RECURRING',
	ONE_TIME: 'ONE_TIME'
}

export const ProgramStatus = {
	PUBLISHED: 'PUBLISHED',
	DRAFT: 'DRAFT',
	ARCHIVED: 'ARCHIVED'
}

export const ProgramStatuses = [
	ProgramStatus.PUBLISHED,
	ProgramStatus.DRAFT,
	ProgramStatus.ARCHIVED,
]

export const ProgramStatusColor = {
	PUBLISHED: {
		text: 'text-green-success',
		background: 'bg-green-subtle'
	},
	DRAFT: {
		text: 'text-blue-light',
		background: 'bg-blue-subtle'
	},
	ARCHIVED: {
		text: 'text-red-secondary',
		background: 'bg-red-subtle'
	}
}

export const ProgramTypeColor = {
	RECURRING: 'text-red-primary',
	ONE_TIME: 'text-purple-secondary'
}

export const DAY_OF_WEEK = [
	'Minggu',
	'Senin',
	'Selasa',
	'Rabu',
	'Kamis',
	'Jumat',
	'Sabtu',
]
